<template>
  <v-container style="width: 100vw !important">
    <v-row
        class="mx-0"
        :class="{ v3_heading_mobile_view: $vuetify.breakpoint.smAndDown }"
    >
      <v-col
          cols="8"
          md="6"
          style="padding-left:0px; padding-top: 10px; padding-bottom: 10px;"
      >
      <span class="headline font-weight-light ma-3">
        Moja škola
        <v-icon
            slot="divider"
            @click="reloadAllData"
            style="padding-bottom: 2px;"
        >mdi-refresh</v-icon
        >
      </span>      </v-col>
      <v-col cols="4">
        <v-container>
          <div class="d-flex justify-end">
            {{ getTodayDate }}
          </div>
        </v-container>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row
      ><v-col cols="12" md="9">
        <v-tabs
            v-model="selected"
            v-if="showTabs"
            style="border-bottom: thin solid rgba(0, 0, 0, 0.12);"
        >
          <v-tab
              v-for="(link, index) in navLinks"
              :key="link.title + '_' + index"
              @click="selected = index"
              style="min-width: 192px;"
          >{{ link.title }}</v-tab>
        </v-tabs>
      </v-col>
      </v-row>
    </v-container>

    <div v-if="showTabs">
      <v-tabs-items v-model="selected">
        <v-tab-item v-for="item in navLinks" :key="item.title">
          <component
              v-bind:is="item.content"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import SchoolBestStudents from "@/components/myschool/SchoolBestStudents";
import SchoolInfo from "@/components/myschool/SchoolInfo";
import SchoolEducationalFields from "@/components/myschool/SchoolEducationalFields";
import {serverBus} from "@/main";
export default {
  components: {
    SchoolInfo,SchoolEducationalFields,SchoolBestStudents
  },
  computed: {
    navLinks(){
      return [
        {title: "Podaci o školi", content: 'SchoolInfo'},
        {title: "Smjerovi", content: 'SchoolEducationalFields'},
        {title: "Učenici generacije", content: 'SchoolBestStudents'}
      ]
    },
    getTodayDate(){
      var todayDate = ''
      var days = ["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"]
      var dd = new Date

      todayDate += days[dd.getDay()] + ', ' + dd.getDate() + '.' + (dd.getMonth() + 1) + '.' + dd.getFullYear()

      return todayDate
    },
  },
  methods: {
    reloadAllData() {
      serverBus.$emit("reload-all-data");
    },
  },
  data() {
    return {
      showTabs: true,
      graduationType: null,
      selected: 0
    };
  },
};
</script>
